import React from 'react';
import MultiplePublicMerchantsAction
  from '@/Pages/Merchants/Assets/MultiplePublicMerchantsAction/MultiplePublicMerchantsAction';

const PublicMerchantsBottomPanel = ({handleCheckAll, checked, parentCheckbox}) => {

  return (
    <tfoot className='border-t'>
    <tr>
      <td className="px-1 pt-5 pb-4 w-1">
        <input type="checkbox" onChange={handleCheckAll} ref={parentCheckbox} defaultChecked={false}/>
      </td>
      <td>
        <MultiplePublicMerchantsAction checked={checked}/>
      </td>
    </tr>
    </tfoot>
  );
};

export default PublicMerchantsBottomPanel;
